import React from 'react';
import { bool, func, string } from 'prop-types';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import LaptopIcon from '@material-ui/icons/LaptopMac';

import InstructionCard from './InstructionCard';
import laptopPlayIcon from 'resources/images/laptop-play.png';

import styles from './styles/index.scss';

export default class NewClusterDialog extends React.Component {
  static propTypes = {
    open: bool,
    onClose: func,
    onSubmit: func,
    organizationId: string
  };

  state = {
    clusterName: '',
    clusterId: ''
  };

  handleTextFieldChange = type => event => {
    const { value } = event.target;

    if (type === 'name') {
      this.setState({
        clusterName: value
      });
    }

    if (type === 'id') {
      this.setState({
        clusterId: value
      });
    }
  };

  handleSubmit = () => {
    const { clusterName } = this.state;
    const { onSubmit, onClose, organizationId } = this.props;

    onSubmit({ name: clusterName, organizationId });
    onClose();
  };

  render() {
    const { open, onClose } = this.props;

    return (
      <Dialog
        open={open}
        onClose={onClose}
        disableBackdropClick
        disableEscapeKeyDown
      >
        <DialogTitle disableTypography classes={{ root: styles.dialogTitle }}>
          <Typography variant="h6">
            <LaptopIcon
              style={{ width: 50, height: 50, marginRight: 20 }}
            />{' '}
            Connect New aiWare Cluster
          </Typography>
          <IconButton
            disableRipple
            style={{ padding: '0px' }}
            color="inherit"
            onClick={onClose}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <InstructionCard
            headerText="Learn More About Hybrid Deployments"
            // eslint-disable-next-line max-len
            contentText="In Connected mode, you will be able to utilize aiWARE's multi-variant cognitive search as well as a collection of UI and API based intefraces. To learn more, click here."
            img={laptopPlayIcon}
          />
          <TextField
            variant="outlined"
            label="Cluster Name"
            fullWidth
            placeholder="MyCluster1"
            className={styles.textField}
            onChange={this.handleTextFieldChange('name')}
          />
          <TextField
            variant="outlined"
            label="Cluster ID"
            fullWidth
            placeholder="UUID"
            className={styles.textField}
            onChange={this.handleTextFieldChange('id')}
          />
          <Typography variant="body1" color="textSecondary" gutterBottom>
            To get the ID, run &apos;echo $AIWARE_INIT_TOKEN&apos; in your
            cluster
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button
            variant="outlined"
            color="primary"
            onClick={this.handleSubmit}
          >
            Connect
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}



// WEBPACK FOOTER //
// ./src/client/plugins/aiware/components/NewClusterDialog.js